import { useEffect, useState } from "react";
import SequenceService from "../Services/SequenceService";
import Form from 'react-bootstrap/Form';
import { Link } from "react-router-dom";
import PubSub from 'pubsub-js';

function AdminSequenceList() {

    const [sequences, setSequences] = useState([]);
    const [searchParam, setSearchParam] = useState('');
    const [searchEmail, setSearchEmail] = useState('');
    const [filteredSequences, setFilteredSequences] = useState([]);
    const [showOnlyNoLeads, setShowOnlyNoLeads] = useState(false);

    useEffect(() => {
        let filteredSequences = sequences;

        // Filter by search parameter
        if (searchParam) {
            filteredSequences = filteredSequences.filter(s =>
                s?.user?.name.toLowerCase().includes(searchParam.toLowerCase()) ||
                s?.name?.toLowerCase().includes(searchParam.toLowerCase())
            );
        }

        if (searchEmail) {
            filteredSequences = filteredSequences.filter(s =>
                s?.user?.email.toLowerCase().includes(searchEmail.toLowerCase())
            );
        }

        // Filter by no leads
        if (showOnlyNoLeads) {
            filteredSequences = filteredSequences.filter(s =>
                s.leads_id.length === 0 || s.leads_available === 0
            );
        }

        setFilteredSequences(filteredSequences);
    }, [searchParam, showOnlyNoLeads, sequences, searchEmail]);

    useEffect(() => {
        getAdminSequences();
    }, []);

    async function getAdminSequences() {
        let data = await SequenceService.getAdminSequences();
        setSequences(data);
    }

    function onClickOnActivateSequence(sequence) {
        sequence.isActive = !sequence.isActive;
        SequenceService.updateSequence(sequence);
        setSequences([...sequences]);
        PubSub.publish('show-basic-notification', {
            title: 'Campaign updated',
            message: `Campaign has been ${sequence.isActive ? 'activated' : 'deactivated'}`
        });
    }

    function renderSequences() {

        let sequencesToRender = (searchParam || searchEmail) ? filteredSequences : sequences;

        return sequencesToRender.map((sequence, index) => (
            <div className="list-group" key={`sequence${index}`}>
                <div to={'/sequences/' + sequence._id}
                    className="sequence-list-item"
                    aria-current="true">

                    <Link to={'/sequences/' + sequence._id} className="w-100 pointer blank-link">
                        <div className="d-flex w-100 justify-content-between">
                            <p className="mb-1 bold fs-15">{sequence.name}</p>
                        </div>
                        <small>
                            <span className="text-primary"> {sequence.user.name}</span>
                            <span className="mx-1 text-secondary">●</span> <span className="small">{sequence.user.email}</span>
                            <span className="mx-1 text-secondary">●</span> <span className="small">{sequence.steps.length} steps</span>
                            <span className="mx-1 text-secondary">●</span> <span className="small">{sequence.leads_id.length} leads</span>
                            <span className="mx-1 text-secondary">●</span> <span className="small">{sequence.leads_available} availables</span>
                        </small>
                    </Link>

                    <Form.Check // prettier-ignore
                        type="switch"
                        id="custom-switch"
                        className="mx-3"
                        onChange={() => onClickOnActivateSequence(sequence)}
                        checked={sequence.isActive}
                        style={{ transform: 'scale(1.3)' }}
                    />

                    {/*
                         <Dropdown>
                        <Dropdown.Toggle variant="muted"
                            className="no-chevron btn-sm" id="dropdown-basic">
                            <i className="fas fa-ellipsis-h"></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => archiveSequence(sequence)}>Archive</Dropdown.Item>
                            <NavLink className='dropdown-item' to={`/sequences/${sequence._id}/settings`}>
                                Edit
                            </NavLink>
                        </Dropdown.Menu>
                    </Dropdown>

                    */}

                </div>

            </div>
        ))
    }


    return (
        <div>
            <div className="ulysses-sequences-title">
                <h5 className="bold">
                    Campaigns
                    (<span className="mx-2 fs-13 text-danger">
                        {sequences.length}
                    </span>)
                </h5>
            </div>



            <div className="ulysses-sequences-container">
                <div className="ulysses-sequences-body">

                    <div className="ulysses-sequences-buttons d-flex my-2 justify-content-between">
                        <div className="d-flex gap-3">
                            <div>
                                <label htmlFor="search-user-input" className="form-label me-2 mb-0 bold fs-12">Users</label>
                                <input
                                    id="search-user-input"
                                    type="text"
                                    style={{ width: '200px' }}
                                    className='form-control form-control-sm'
                                    value={searchParam}
                                    onChange={(e) => setSearchParam(e.target.value)}
                                    placeholder='Search user'
                                />
                            </div>

                            <div>
                                <label htmlFor="search-user-input" className="form-label me-2 mb-0 bold fs-12">Email</label>
                                <input
                                    id="search-user-input"
                                    type="text"
                                    style={{ width: '200px' }}
                                    className='form-control form-control-sm'
                                    value={searchEmail}
                                    onChange={(e) => setSearchEmail(e.target.value)}
                                    placeholder='Search by email'
                                />
                            </div>

                        </div>


                        <div className="d-flex align-items-center">
                            <Form.Check // prettier-ignore
                                type="switch"
                                id="no-leads-switch"
                                className="mx-2"
                                onChange={() => setShowOnlyNoLeads(!showOnlyNoLeads)}
                                checked={showOnlyNoLeads}
                                style={{ transform: 'scale(1.2)' }}
                            />
                            <label htmlFor="no-leads-switch" className="mb-0 small">
                                Campaigns with no leads
                            </label>
                        </div>
                    </div>

                    <div className="ulysses-sequences-table">
                        {renderSequences()}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminSequenceList;